import { ChangePasswordModalComponent } from './change-password-modal/change-password-modal.component';
import { ImgCaptionModalComponent } from './img-caption-modal/img-caption-modal.component';
import { AddRoomSuccessModalComponent } from './add-room-success-modal/add-room-success-modal.component';
import { AddRoomModalComponent } from './add-room-modal/add-room-modal.component';
import { PublishedModalComponent } from './published-modal/published-modal.component';
import { FreeTrialBenefitsComponent } from './free-trial-benefits/free-trial-benefits.component';
import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
} from '@angular/core';

import { ClooperCommonModule } from '@clooper/common';
import { modals, ClooperModalsModule } from '@clooper/modals';
import { RouterModule, Routes } from '@angular/router';
import { CancelBookingComponent } from './cancel-booking/cancel-booking.component';
import { ResendReceiptComponent } from './resend-receipt/resend-receipt.component';
import { ContactSupportComponent } from './contact-support/contact-support.component';
import { ModifyBookingComponent } from './modify-booking/modify-booking.component';
import { ApprovedPromptComponent } from './approved-prompt/approved-prompt.component';
import { InviteEmployeeComponent } from './invite-employee/invite-employee.component';
import { ViewCorporateAccountPaymentComponent } from './view-corporate-account-payment/view-corporate-account-payment.component';
import { ExtraServiceModalComponent } from './extra-service-modal/extra-service-modal.component';
import { ExtraServiceFlightComponent } from './extra-service-flight/extra-service-flight.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ExtraServiceRentalComponent } from './extra-service-rental/extra-service-rental.component';
import { ExtraServiceAirportComponent } from './extra-service-airport/extra-service-airport.component';
import { ExtraServiceCarComponent } from './extra-service-car/extra-service-car.component';
import { ExtraServiceVisaComponent } from './extra-service-visa/extra-service-visa.component';
import { ExtraServiceTravelComponent } from './extra-service-travel/extra-service-travel.component';
import { ExtraServiceRemovalComponent } from './extra-service-removal/extra-service-removal.component';
import { SharedModule } from '../shared/shared.module';
import { ResendFlightReceiptComponent } from './resend-flight-receipt/resend-flight-receipt.component';
import { BookingLimitsComponent } from './booking-limits/booking-limits.component';
import { BookingApprovalResponseModalComponent } from './booking-approval-response-modal/booking-approval-response-modal.component';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { BookingDetailsComponent } from './booking-details/booking-details.component';
import { DashboardTourModalComponent } from './dashboard-tour-modal/dashboard-tour-modal-component';
import { AddDocumentModalComponent } from './add-document-modal/add-document-modal.component';
import { EditDocumentModalComponent } from './edit-document-modal/edit-document-modal.component';
import { AddFlyerInfoModalComponent } from './add-flyer-info-modal/add-flyer-info-modal.component';
import { EditFlyerInfoModalComponent } from './edit-flyer-info-modal/edit-flyer-info-modal.component';
import { RemoveDocumentModalComponent } from './remove-document-modal/remove-document-modal.component';
import { RemoveMembershipModalComponent } from './remove-membership-modal/remove-membership-modal.component';
export const routes: Routes = [
  // { path: 'payment:plan', component: PaymentModalComponent, outlet: 'modal' },
];

modals.register(
  // { 'reset password': ResetPasswordModalComponent },
  { 'free-trial-benefit': FreeTrialBenefitsComponent },
  { 'add-room': AddRoomModalComponent },
  { 'add-room-success': AddRoomSuccessModalComponent }
);

export const components: any[] = [
  FreeTrialBenefitsComponent,
  PublishedModalComponent,
  AddRoomSuccessModalComponent,
  ContactSupportComponent,
  CancelBookingComponent,
  ResendReceiptComponent,
  ModifyBookingComponent,
  ApprovedPromptComponent,
  InviteEmployeeComponent,
  ViewCorporateAccountPaymentComponent,
  ExtraServiceModalComponent,
  ExtraServiceFlightComponent,
  ExtraServiceRentalComponent,
  ExtraServiceAirportComponent,
  ExtraServiceCarComponent,
  ExtraServiceVisaComponent,
  ExtraServiceTravelComponent,
  ExtraServiceRemovalComponent,
  ResendFlightReceiptComponent,
  BookingLimitsComponent,
  BookingApprovalResponseModalComponent,
  ErrorModalComponent,
  BookingDetailsComponent,
  DashboardTourModalComponent,
  AddDocumentModalComponent,
  EditDocumentModalComponent,
  AddFlyerInfoModalComponent,
  EditFlyerInfoModalComponent,
  RemoveDocumentModalComponent,
  RemoveMembershipModalComponent
];

@NgModule({
  imports: [
    ClooperCommonModule,
    SharedModule,
    ClooperModalsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
  ],
  declarations: components,
  exports: components,
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModalsModule {}
